export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const SET_SELECTED_RESERVATION_IDS = "SET_SELECTED_RESERVATION_IDS";
export const SET_SELECTED_ROOM_ID = "SET_SELECTED_ROOM_ID";
export const SET_SELECTED_RESERVATION_ID = "SET_SELECTED_RESERVATION_ID";
export const FETCH_ROOMS_SUCCESS = "FETCH_ROOMS_SUCCESS";
export const CREATE_ROOM = "CREATE_ROOM";
export const UPDATE_ROOM = "UPDATE_ROOM";
export const UPLOAD_ROOM_PICTURE = "UPLOAD_ROOM_PICTURE";
export const FETCH_RESERVATIONS_MONTH = "FETCH_RESERVATIONS_MONTH";
export const CREATE_RESERVATION = "CREATE_RESERVATION"
export const UPDATE_RESERVATION = "UPDATE_RESERVATION"
export const FETCH_RESERVATION_DETAILS = "FETCH_RESERVATION_DETAILS"
export const CREATE_RESERVATION_DETAILS = "CREATE_RESERVATION_DETAILS"
export const DELETE_SINGLE_RESERVATION = "DELETE_SINGLE_RESERVATION";
export const REMOVE_RESERVATION_DATE = "REMOVE_RESERVATION_DATE";
